import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import StyledButtonContainer from "@/components/editor/themes/nolan/shared/cta-button";

export const VideoAndParagraphList = withViewportStyle("div")`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${rem(24)};

  ${StyledButtonContainer} {
    margin-top: ${rem(8)};
  }

  ${(props) => props.$viewport.mobile`
    grid-template-columns: 1fr;
    grid-auto-flow: dense;

    .paragraph-item-sub-title {
      grid-row: 2;
    }
  `}
`;

export const PaddingWrapper = withViewportStyle("div")`
  padding: ${rem(80)} ${rem(24)};
  
  ${(props) => props.$viewport.mobile` 
    padding: ${rem(40)} ${rem(16)};
  `}
`;
